import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export function when(iso: string): string {
  if (!iso) return ''
  const at = dayjs(iso)
  if (!at.isValid()) return ''
  return at.isAfter(dayjs().subtract(7, 'day')) ? at.fromNow() : at.format('D MMM YYYY HH:mm')
}

export function exactTime(iso: string): string {
  const at = dayjs(iso)
  return at.isValid() ? at.format('D MMM YYYY, HH:mm:ss') : ''
}
